import styled from 'styled-components';
import { usePatternContext } from '../../../context/PatternContext';
import { useState } from 'react';
import { Pattern1, Pattern3, Pattern2 } from './pattern/data';
import PatternItem from './pattern/PatternItem';

interface Iprops {
  tab: string;
}

const SelectedItem = ({ tab }: Iprops) => {
  const {
    pattern1,
    pattern2,
    pattern3,
    isStep1Done,
    isStep2Done,
    isStep3Done,
    setSelectedTab,
  } = usePatternContext();
  const renderingData = () => {
    if (tab === '핵심 알고리즘') {
      if (isStep1Done) {
        return <PatternItem tab={'핵심 알고리즘'} />;
      } else {
        return (
          <NotSelectBox>
            <img src="assets/images/icon/circle_2.svg"></img>
            <div>
              <span>핵심 알고리즘</span>
            </div>
            <div
            // onClick={() => {
            //   setSelectedTab('핵심 알고리즘');
            // }}
            >
              선택
            </div>
          </NotSelectBox>
        );
      }
    } else if (tab === '특수 알고리즘') {
      if (isStep2Done) {
        return <PatternItem tab={'특수 알고리즘'} />;
      } else {
        return (
          <NotSelectBox>
            <img src="assets/images/icon/circle_3.svg"></img>
            <div>
              <span>특수 알고리즘</span>
            </div>
            <div>선택</div>
          </NotSelectBox>
        );
      }
    } else {
      return <PatternItem tab={'분석 기준'} />;
    }
  };
  return <Container>{renderingData()}</Container>;
};

export default SelectedItem;

const NotSelectBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  span {
    font-size: 16px;
    font-weight: 700;
    line-height: 26.4px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 24px 16px;
  border-radius: 16px;
  background-color: #ffffff;
`;
